module.exports = {"id":"210489","name":"Louis Schaub","rating":"74","photo":"./data/images/photos/0/210489.png","club":{"name":"SK Rapid Vienne","logo":"./data/images/clubs/SKRapidVienne.png"},"positions":["MD","MG","MOC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LouisSchaub0.json
// module id = 2543
// module chunks = 0